import { isNil } from 'lodash';

import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';
import types from './mutation-types';

export function fetchEvaluationList({ dispatch }, { classId, filters }) {
  return http.get(`${MINERVA_API_URL}/classes/${classId}/evaluation`, { params: filters })
    .then(res => (
      dispatch('setEvaluationListInStore', res.data)
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching evaluation list:', err);
      return Promise.reject(err);
    });
}

export function fetchEvaluation({ dispatch }, { studentId, filters, index }) {
  return http.get(`${MINERVA_API_URL}/users/${studentId}/evaluation`, { params: filters })
    .then(res => (
      dispatch('setEvaluationInStore', { index, evaluation: res.data })
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching evaluation:', err);
      return Promise.reject(err);
    });
}

export function saveEvaluationList({ dispatch }, { classId, evaluationList }) {
  return http.post(`${MINERVA_API_URL}/classes/${classId}/evaluation`, evaluationList)
    .catch((err) => {
      // TODO: handle error
      console.error('err while saving evaluation list:', err);
      return Promise.reject(err);
    });
}

export function fetchEvaluationCriteria({ dispatch }, { classId, filters }) {
  return http.get(`${MINERVA_API_URL}/classes/${classId}/criteria`, { params: filters })
    .then(res => (
      dispatch('setEvaluationCriteriaInStore', res.data.criteria[0])
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching evaluation criteria:', err);
      return Promise.reject(err);
    });
}

export function saveEvaluationCriteria({ dispatch }, { classId, criteriaBody }) {
  return http.post(`${MINERVA_API_URL}/classes/${classId}/criteria`, criteriaBody)
    .then(() => (
      dispatch('setEvaluationCriteriaInStore', criteriaBody.criteria[0])
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while saving evaluation criteria:', err);
      return Promise.reject(err);
    });
}

export function fetchEvaluationDomains({ dispatch }, { classId, filters }) {
  return http.get(`${MINERVA_API_URL}/classes/${classId}/domains`, { params: filters })
    .then(res => (
      Promise.all([
        dispatch('setEvaluationDomains', { domains: res.data.domains || [], classId }),
        Promise.resolve()
          .then(() => {
            if (isNil(res.data.selected_domains)) {
              const domainIds = res.data.domains.map(domain => (domain.id));

              return dispatch('setSelectedEvaluationDomainIds', { selectedDomainIds: domainIds, classId });
            }

            return dispatch('setSelectedEvaluationDomainIds', { selectedDomainIds: res.data.selected_domains || [], classId });
          }),
      ])
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching evaluation domains:', err);
      return Promise.reject(err);
    });
}

export function saveEvaluationDomains({ dispatch }, { classId, domainBody }) {
  return http.post(`${MINERVA_API_URL}/classes/${classId}/domains`, domainBody)
    .catch((err) => {
      // TODO: handle error
      console.error('err while saving evaluation domains:', err);
      return Promise.reject(err);
    });
}

export function setEvaluationListInStore({ commit }, evaluationList) {
  commit(types.SET_EVALUATION_LIST, evaluationList);

  return Promise.resolve(evaluationList);
}

export function setEvaluationInStore({ commit }, { index, evaluation }) {
  commit(types.SET_EVALUATION, { index, evaluation });

  return Promise.resolve(evaluation);
}

export function setEvaluationCriteriaInStore({ commit }, criteria) {
  commit(types.SET_EVALUATION_CRITERIA, criteria);

  return Promise.resolve(criteria);
}

export function setEvaluationFilter({ commit }, filterInfo) {
  commit(types.SET_EVALUATION_FILTER, filterInfo);

  return Promise.resolve();
}

export function setEvaluationOrderBy({ commit }, orderBy) {
  commit(types.SET_EVALUATION_ORDER_BY, orderBy);

  return Promise.resolve();
}

export function setEvaluationDomains({ commit }, params) {
  commit(types.SET_CLASS_EVALUATION_DOMAINS, params);

  return Promise.resolve(params);
}

export function setSelectedEvaluationDomainIds({ commit }, params) {
  commit(types.SET_SELECTED_CLASS_EVALUATION_DOMAINS, params);

  return Promise.resolve(params);
}



// WEBPACK FOOTER //
// ./src/app/evaluations/store/actions.js